import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-verify',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './verify.component.html',
  styles: [
  ]
})
export class VerifyComponent implements OnInit {

  code?: number;
  isSuccess = false;
  isLoading = false;
  message: any;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

  doVerif(){
    this.isLoading = true;
    const data = {
      codeOtp: this.code,
    }
    this.authService.doVerify(data).subscribe((value: any) => {
      this.isSuccess = true;
      this.isLoading = false;
      this.message = value.message;
      this.router.navigate(['/login']);
    })
  }

}
